<template>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">×</span>
        </button>
        <i class="fa fa-trash modal-icon"></i>
        <h4 class="modal-title">削除の確認</h4>
      </div>
      <div class="modal-body">
        <p>
          該当の項目を削除してもよろしいですか？
        </p>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-default pull-left"
          data-dismiss="modal"
        >
          キャンセル
        </button>
        <button
          type="button"
          class="btn btn-primary"
          @click="remove(freetext_index, modal_id)"
        >
          実行する
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["freetext_index", "modal_id", "freetext_array"],
  methods: {
    remove(freetext_index, modal_id) {
        $(modal_id).modal('hide');
        this.freetext_array.splice(this.freetext_index, 1);
    },
  },
};
</script>

